<!-- padding-bottom: room to scroll the last field clear of the fixed button bar -->
<div style="padding-top: 1rem; padding-bottom: 96px;" class="row-not-wrap">

  <div class="col-md-3 col-lg-2 register-left-side-menu">

    <mat-stepper [linear]="true" orientation="vertical" #stepper>
      <mat-step [stepControl]="mgtmCoAddress">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
    
        </ng-template>
        <ng-template matStepLabel>Mgmt Co Address</ng-template>
        </mat-step>
      <mat-step [stepControl]="mgtnCoReporting">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
      
        </ng-template>
        <ng-template matStepLabel>Mgmt Co Reporting</ng-template>
        </mat-step>
        <mat-step [stepControl]="entityRentalPropertyLicense">
          <ng-template matStepperIcon="edit">
            <mat-icon class="icon-display">check</mat-icon>
        
          </ng-template>
        <ng-template matStepLabel>Mgmt Co License</ng-template>
        </mat-step>
      <mat-step [stepControl]="ownerForm">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
      
        </ng-template>
        <ng-template matStepLabel>Rental Owner</ng-template>
        </mat-step>
      <mat-step [stepControl]="rentalProperty">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
      
        </ng-template>
        <ng-template matStepLabel>Rental Property</ng-template>
        </mat-step>
      <mat-step [stepControl]="rentalPropertyLicense">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
      
        </ng-template>
        <ng-template matStepLabel>Rental Property Licenses</ng-template>
      </mat-step>
      <mat-step [stepControl]="agreements">
        <ng-template matStepperIcon="edit">
          <mat-icon class="icon-display">check</mat-icon>
      
        </ng-template>
        <ng-template matStepLabel>Agreements</ng-template>
        </mat-step>
        </mat-stepper>
        </div>
  <div *ngIf="stepper.selectedIndex == 0" class="col-md-8 col-xs-12">
    <div class="row">
      <form [formGroup]="mgtmCoAddress">
        <div class="form-container">
          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline" requiered>
                <mat-label style="font-size: 16px !important;">Business legal name</mat-label>
                <input matInput formControlName="businessLegalName" placeholder="Business legal name" required>
                <mat-error>Business legal name is required</mat-error>
                </mat-form-field>
                </div>
                </div>

          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label style="font-size: 16px !important;">Business DBA name</mat-label>
                <input matInput formControlName="businessDbaName" placeholder="Business DBA name">
                </mat-form-field>
                </div>
                </div>
                <div class="form-row">
                  <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label style="font-size: 16px !important;">Website url</mat-label>
                <input matInput formControlName="webUrl" placeholder="Website url">
                <mat-error>Website url is invalid</mat-error>
                </mat-form-field>
                </div>
                </div>
                <div class="form-row">
                  <div class="form-col">

              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>Business’s street address</mat-label>
                <input matInput class="form-outline form-control" placeholder="Business’s street address"
                  formControlName="businnesStreetAddress" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                    (onSelectionChange)="selectPlace(suggestion)">
                    {{ suggestion.description }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error>Business’s street address is required</mat-error>
                </mat-form-field>
                </div>
                </div>

          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline" requiered>
                <mat-label style="font-size: 16px !important;">Apt/Unit/Suite</mat-label>
                <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite">
                </mat-form-field>
                </div>
                </div>
                <div class="form-row">
                  <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" placeholder="City">
                <mat-error>City is required</mat-error>
                </mat-form-field>
                
                </div>
                
                <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>State</mat-label>

                <mat-select formControlName="state" placeholder="State">

                  @for (state of states; track state) {
                  <mat-option [value]="state.id">{{state.name}}</mat-option>
                  }
                </mat-select>
                <mat-error>State is required</mat-error>
              </mat-form-field>
              
              </div>
              
              
              <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="zipCode" laceholder="Zip Code">
                <mat-error *ngIf="this.mgtmCoAddress.get('zipCode')?.errors?.['pattern'] && (mgtmCoAddress.get('zipCode')?.touched)">Zip
                  Code is invalid</mat-error>

                <mat-error
                  *ngIf="this.mgtmCoAddress.get('zipCode')?.errors?.['required'] && (mgtmCoAddress.get('zipCode')?.touched)">Zip
                  Code is required</mat-error>
                </mat-form-field>
                
                
                </div>
                </div>
                <div class="form-row">
                  <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label>Notes</mat-label>
                <textarea matInput formControlName="note" placeholder="Notes"></textarea>
                </mat-form-field>
            </div>
          </div>
        </div>
        </form>
        </div>
        </div>

  <div *ngIf="stepper.selectedIndex == 1" class="col-md-8 col-xs-12">
    <app-rental-property-reporting-form [rentalPropertyReporting]="this.mgtnCoReporting"
      #rentalPropertyReportingFormComponent [states]="this.states"></app-rental-property-reporting-form>
  </div>

  <div *ngIf="stepper.selectedIndex == 2" class="col-md-8 col-xs-12">

    <app-entitylicensestep [entityRentalPropertyLicense]="this.entityRentalPropertyLicense"
      #entitylicensestep></app-entitylicensestep>
    
    </div>
  <div *ngIf="stepper.selectedIndex == 3" class="col-md-8 col-xs-12">
    <form [formGroup]="ownerForm">
      <div class="form-container margin-right rental-main-content">
        <div class="row gap-32 margin-bottom flex-direction-xs-col">
          <div class="col-md-4 col-xs-12">&nbsp;</div>
          <div class="col-md-8 col-xs-12">
            <div class="row gap-32 flex-direction-xs-col">
              <mat-radio-group aria-label="Select rental owner's address type">
                <mat-label>Select rental owner's address type</mat-label>
                <mat-radio-button (change)="radioChangeAddress($event)" [checked]="true" color="primary"
                  value="1">Domestic</mat-radio-button>
                <mat-radio-button (change)="radioChangeAddress($event)" color="primary" value="2">International</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>     
        </div>
        <!-- Owner contact on top, two per row: the narrow left column truncated these long labels (QA) -->
        <div class="form-row">
            <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline" requiered>
                    <mat-label style="font-size: 16px !important;">Rental Property owner’s First name</mat-label>
                    <input matInput formControlName="firstName" placeholder="Rental Property owner’s First name" required>
                    <mat-error>Rental Property owner’s First name is required</mat-error>
                  </mat-form-field>
            </div>
            <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label style="font-size: 16px !important;">Rental Property owner’s Last name</mat-label>
                    <input matInput formControlName="lastName" placeholder="Rental Property owner’s Last name" required>
                    <mat-error>Rental Property owner’s Last name is required</mat-error>
                  </mat-form-field>
            </div>
        </div>
        <div class="form-row">
            <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label style="font-size: 16px !important;">Rental Property owner’s email address</mat-label>
                    <input matInput formControlName="email" placeholder="Rental Property owner’s email address" required>
                    <mat-error *ngIf="this.ownerForm.get('email')?.errors?.['email'] && (ownerForm.get('email')?.touched)">Rental
                      Property owner's email address is invalid</mat-error>
                
                    <mat-error *ngIf="this.ownerForm.get('email')?.errors?.['required'] && (ownerForm.get('email')?.touched)">
                      Rental Property owner's email address is required
                    </mat-error>
                
                  </mat-form-field>
            </div>
            <div class="form-col">
              <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label style="font-size: 16px !important;">Rental Property owner’s Phone Number</mat-label>
                    <input matInput appPhoneFormat formControlName="phoneNumber" placeholder="Rental Property owner’s Phone Number" required>
                    <mat-error
                      *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['pattern'] && (ownerForm.get('phoneNumber')?.touched)">Rental
                      Property owner's phone number is invalid</mat-error>
                
                    <mat-error
                      *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['required'] && (ownerForm.get('phoneNumber')?.touched)">Rental
                      Property owner's phone number is required</mat-error>
                
                  </mat-form-field>
            </div>
        </div>
        <div class="form-row">
          <div class="form-col span-2"><!-- Second Column -->
        
              <div class="form-row">
                <div *ngIf="addressType == '1'" class="form-col">
                  <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label>Owners Street Address</mat-label>
                    <input matInput class="form-outline form-control" placeholder="Owners Street Address"
                      formControlName="ownerStreetAddress" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                        (onSelectionChange)="selectPlaceOwner(suggestion)">
                        {{ suggestion.description }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error>Owners Street Address is required</mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="addressType == '2'" class="form-col">
                  <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label>Address’s name</mat-label>
                    <input class="form-outline form-control" formControlName="addressName" matInput placeholder="Address’s name">
                
                    <mat-error>Address’s name is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-row">
                <div *ngIf="addressType == '1'" class="form-col">
                  <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label>Apt/Unit/Suite</mat-label>
                    <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite">

                  </mat-form-field>
                </div>
                <div *ngIf="addressType == '2'" class="form-col">

                  <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label>Street address or post office box number</mat-label>
                    <input formControlName="addressOrPoBox" class="form-outline form-control" matInput
                      placeholder="Street address or post office box number">

                    <mat-error>Street address or post office box numbe is required</mat-error>
                  </mat-form-field>
                </div>

              </div>
              <div class="form-row">
                <div *ngIf="addressType == '1'" class="form-col">
                  <div class="form-row">
                    <div class="form-col">
                      <mat-form-field class="mat-form-field-100" appearance="outline">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" placeholder="City">
                        <mat-error>City is required</mat-error>
                      </mat-form-field>
                    </div>
              
                    <div class="form-col">
                      <mat-form-field class="mat-form-field-100" appearance="outline">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state" placeholder="State">
                          @for (state of states; track state) {
                          <mat-option [value]="state.id">{{state.name}}</mat-option>
                          }
                        </mat-select>
                        <mat-error>State is required</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="form-col">
                      <mat-form-field class="mat-form-field-100" appearance="outline">
                        <mat-label>Zip Code</mat-label>
                        <input matInput formControlName="zipCode" laceholder="Zip Code">
                        <mat-error
                          *ngIf="this.ownerForm.get('zipCode')?.errors?.['pattern'] && (ownerForm.get('zipCode')?.touched)">Zip
                          Code is invalid</mat-error>
              
                        <mat-error
                          *ngIf="this.ownerForm.get('zipCode')?.errors?.['required'] && (ownerForm.get('zipCode')?.touched)">Zip
                          Code is required</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div *ngIf="addressType == '2'" class="form-col">
                  <mat-form-field appearance="outline">
                    <mat-label>City, State, Province</mat-label>
                    <input class="form-outline form-control" formControlName="cityStateProvince" matInput
                      placeholder="City, State, Province">
                    <mat-error>City, State, Province is required</mat-error>
              
                  </mat-form-field>
                </div>
              </div>
              <div class="form-row">
                <div *ngIf="addressType == '2'" class="form-col">
                  <mat-form-field class="mat-form-field-100" appearance="outline">
                    <mat-label>Country</mat-label>
              
                    <mat-select formControlName="country" placeholder="Country">
              
                      @for (state of countries; track state) {
                      <mat-option [value]="state.id">{{state.name}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>Country is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div *ngIf="stepper.selectedIndex == 4" class="col-md-8 col-xs-12">
    <div class="form-container" style="width: 100vh;">
      <app-rental-property [rentalProperty]="this.rentalProperty" #rentalPropertyComponent [isMotelHotel]="false"
        [states]="this.states"></app-rental-property>

    </div>
  </div>
  <div *ngIf="stepper.selectedIndex == 5" class="col-md-8 col-xs-12">
    <app-rental-property-license [rentalPropertyLicense]="this.rentalPropertyLicense"
      #rentalPropertyLicenseComponent></app-rental-property-license>
  </div>
  <div *ngIf="stepper.selectedIndex == 6 && !stepCompleted" class="col-md-8 col-xs-12 pr-25">
    <app-agreements [agreements]="this.agreements"></app-agreements>
  </div>
  <div *ngIf="stepper.selectedIndex == 6 && stepCompleted" class="col-md-8 col-xs-12">
    <app-step-complete></app-step-complete>
  </div>
</div>
<div *ngIf="!stepCompleted" style="position: fixed; bottom: 0;width: 100%;background-color: white;">
  <div class="button-stepper-footer">
    <button (click)="openDialog()" mat-stroked-button mat-button
      class="button-stepper-cancel">CANCEL<mat-icon>close</mat-icon></button>
    <button (click)="goToCreateAccuntPage()" *ngIf="stepper.selectedIndex  == 0" mat-stroked-button mat-button
      class="button-stepper-back">
      BACK
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
    <button (click)="goBack(stepper)" *ngIf="stepper.selectedIndex >0" mat-stroked-button mat-button
      class="button-stepper-back">
      BACK
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
    <button [disabled]="!mgtmCoAddress.valid"
      [ngClass]="{'button-stepper-allow': mgtmCoAddress.valid ,'button-stepper': mgtmCoAddress.invalid  }"
      *ngIf="stepper.selectedIndex == 0" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!mgtnCoReporting.valid"
      [ngClass]="{'button-stepper-allow': mgtnCoReporting.valid ,'button-stepper': mgtnCoReporting.invalid }"
      *ngIf="stepper.selectedIndex == 1" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!entityRentalPropertyLicense.valid"
      [ngClass]="{'button-stepper-allow': entityRentalPropertyLicense.valid ,'button-stepper': entityRentalPropertyLicense.invalid  }"
      *ngIf="stepper.selectedIndex == 2" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!ownerForm.valid"
      [ngClass]="{'button-stepper-allow': ownerForm.valid ,'button-stepper': ownerForm.invalid  }"
      *ngIf="stepper.selectedIndex == 3" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!rentalProperty.valid"
      [ngClass]="{'button-stepper-allow': rentalProperty.valid ,'button-stepper': rentalProperty.invalid  }"
      *ngIf="stepper.selectedIndex == 4" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!rentalPropertyLicense.valid"
      [ngClass]="{'button-stepper-allow': rentalPropertyLicense.valid ,'button-stepper': rentalPropertyLicense.invalid  }"
      *ngIf="stepper.selectedIndex == 5" mat-stroked-button mat-button (click)="goForward(stepper)"
      class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!agreements.valid"
      [ngClass]="{'button-stepper-allow': agreements.valid ,'button-stepper': agreements.invalid  }"
      *ngIf="stepper.selectedIndex == 6" mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SUBMIT
      <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    </div>
    </div>